var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ul", { staticClass: "dropdown-menu account-dropdown" }, [
    _c("h6", [_vm._v("My account")]),
    _vm._v(" "),
    _vm.isFutureInterestEnabled
      ? _c(
          "li",
          [
            _c("menu-item", {
              attrs: { path: "/my-companies", text: "Companies" },
              on: { click: _vm.hideMenu },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "li",
      [
        _c("menu-item", {
          attrs: { path: "/deals/submissions", text: "Proposals" },
          on: { click: _vm.hideMenu },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "li",
      [
        _c("menu-item", {
          attrs: { path: "/profile", text: "Account" },
          on: { click: _vm.hideMenu },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "dropdown-footer" }, [
      _c("li", [
        _c("a", { on: { click: _vm.handleLogout } }, [_vm._v("Logout")]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }